export const sxStyle = {
  root: {
    backgroundColor: '#fff',
    border: '4px solid rgba(229, 229, 229, 1)',
    minHeight: '175px',
    m: '20px 0px',
    borderRadius: '8px',
  },

  assistLogo: {
    '@media (min-width:1280px) and (max-width:1599.95px)': {
      backgroundColor: '#000000',
      width: '80px',
      position: 'absolute',
      top: '-22px',
      left: '0px',
      borderRadius: '8px',
    },
  },
  miltiviajeHide: {
    display: 'unset',
    '@media (min-width:1280px) and (max-width:1599.95px)': {
      display: 'none',
    },
  },
  miltiviajeCenter: {
    display: 'unset',
    '@media (max-width:1279.95px)': { display: 'none' },
    '@media (min-width:1600px)': { display: 'none' },
  },
  brSpan: {
    display: 'none',
    '@media (min-width:1280px) and (max-width:1650px)': { display: 'unset' },
  },
  brSpanAux: {
    fontWeight: 400,
    color: 'black',
    pt: '5px',
    ml: '5px',
    textAlign: 'center',
    maxHeight: '28px',
    overflowY: 'hidden',
    fontSize: '20px',
    '@media (min-width:1280px) and (max-width:1650px)': { maxHeight: '56px' },
  },
  list: {
    listStyle: 'none',
    p: 0,
    m: 0,
    '& li:nth-of-type(odd)': { backgroundColor: '#fbfbfb' },
    '& li:nth-of-type(even)': { backgroundColor: '#ebebeb' },
  },
  benefitStyle: {
    backgroundColor: '#000',
    fontWeight: 'bold',
    fontSize: '20px',
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    borderTopRightRadius: '12px',
    borderTopLeftRadius: '12px',
  },
  destinationContainer: {
    backgroundColor: '#f63131',
    borderRadius: '5px',
    maxHeight: '86px',
    p: { xs: '10px 0px', sm: '10px 20px' },
    position: 'relative',
  },

  assistProductTitle: {
    position: 'absolute',
    color: 'white',
    fontSize: '26px',
    fontWeight: 'bold',
    right: '30px',
    top: '26px',
    fontFamily: 'Arial, sans-serif',
    fontStyle: 'oblique',
    '@media (min-width:1280px) and (max-width:1599.95px)': {
      position: 'relative',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: 'max-content',
      top: '20px',
      right: '0px',
    },
  },
  assistRecomended: {
    position: 'absolute',
    color: 'white',
    backgroundColor: '#4b4b4b',
    fontSize: '16px',
    fontWeight: 'bold',
    right: '-10px',
    top: '-14px',
    fontFamily: 'Arial, sans-serif',
    fontStyle: 'oblique',
    p: '4px 8px',
    borderRadius: '6px',
  },
  title: {
    fontWeight: 600,
    fontSize: '22px',
    color: '#000',
  },

  coverageContainer: {
    display: 'flex',
    p: { xs: '0px 70px', sm: '30px 10px' },
    flexDirection: { xs: 'column', sm: 'row' },
  },

  coverageDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    textAlign: { xs: 'start', sm: 'center' },
    p: { xs: '10px 0px', sm: '0px 15px' },
  },
  tarifaLeyenda: {
    fontWeight: 400,
    fontSize: '18px',
    color: 'black',
    pt: '5px',
    ml: '5px',
    textAlign: 'center',
  },
  coverageDetailButton: {
    pt: '15px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 600,
  },
  priceContainer: {
    textAlign: { xs: 'start', sm: 'initial' },
  },
  priceDataContainer: {
    display: 'flex',
    justifyContent: { xs: 'start', sm: 'center' },
    pb: '16px',
    pt: '12px',
  },

  priceTotal: {
    fontSize: '21px',
    color: 'black',
    fontWeight: 'bold',
    pt: '10px',
    textAlign: 'center',
  },

  modalPdf: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '100%!important',
    },
  },
  modalLoadPdf: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '100%!important',
      backgroundColor: 'transparent!important',
      boxShadow: 'none!important',
    },
  },

  closePdfIcon: {
    position: 'absolute',
    right: '5px',
    color: 'red',
    top: '5px',
    cursor: 'pointer',
    left: { xs: '5px', sm: 'initial' },
  },
  paddingCards: {
    p: '0px 20px',
  },
};
